import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import {urlWMSHidroperiodo, formatoPNG} from './configuracion';

const layer09 = new TileLayer({
  title: 'Hidroperíodo 2020-2021',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H2021_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer09.setVisible(false);
  
const layer10 = new TileLayer({
  title: 'Hidroperíodo 2019-2020',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1920_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer10.setVisible(false);
  
const layer11 = new TileLayer({
  title: 'Hidroperíodo 2018-2019',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1819_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer11.setVisible(false);
  
const layer12 = new TileLayer({
  title: 'Hidroperíodo 2017-2018',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1718_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer12.setVisible(false);
  
const layer13 = new TileLayer({
  title: 'Hidroperíodo 2016-2017',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1617_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer13.setVisible(false);
  
const layer14 = new TileLayer({
  title: 'Hidroperíodo 2015-2016',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1516_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer14.setVisible(false);
  
const layer15 = new TileLayer({
  title: 'Hidroperíodo 2014-2015',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1415_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer15.setVisible(false);
  
const layer16 = new TileLayer({
  title: 'Hidroperíodo 2013-2014',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1314_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer16.setVisible(false);
  
const layer17 = new TileLayer({
  title: 'Hidroperíodo 2012-2013',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1213_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer17.setVisible(false);
  
const layer18 = new TileLayer({
  title: 'Hidroperíodo 2011-2012',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1112_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer18.setVisible(false);
  
const layer19 = new TileLayer({
  title: 'Hidroperíodo 2010-2011',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H1011_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer19.setVisible(false);
  
const layer20 = new TileLayer({
  title: 'Hidroperíodo 2009-2010',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0910_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer20.setVisible(false);
  
const layer21 = new TileLayer({
  title: 'Hidroperíodo 2008-2009',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0809_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer21.setVisible(false);
  
const layer22 = new TileLayer({
  title: 'Hidroperíodo 2007-2008',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0708_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer22.setVisible(false);
  
const layer23 = new TileLayer({
  title: 'Hidroperíodo 2006-2007',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0607_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer23.setVisible(false);
  
const layer24 = new TileLayer({
  title: 'Hidroperíodo 2005-2006',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0506_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer24.setVisible(false);
  
const layer25 = new TileLayer({
  title: 'Hidroperíodo 2004-2005',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0405_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer25.setVisible(false);
  
const layer26 = new TileLayer({
  title: 'Hidroperíodo 2003-2004',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0304_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer26.setVisible(false);
  
const layer27 = new TileLayer({
  title: 'Hidroperíodo 2002-2003',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0203_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer27.setVisible(false);
  
const layer28 = new TileLayer({
  title: 'Hidroperíodo 2001-2002',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0102_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer28.setVisible(false);
  
const layer29 = new TileLayer({
  title: 'Hidroperíodo 2000-2001',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H0001_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer29.setVisible(false);
  
const layer30 = new TileLayer({
  title: 'Hidroperíodo 1999-2000',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9900_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer30.setVisible(false);
  
const layer31 = new TileLayer({
  title: 'Hidroperíodo 1998-1999',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H999_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer31.setVisible(false);
  
const layer32 = new TileLayer({
  title: 'Hidroperíodo 1997-1998',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9798_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer32.setVisible(false);
  
const layer33 = new TileLayer({
  title: 'Hidroperíodo 1996-1997',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9697_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer33.setVisible(false);
  
const layer34 = new TileLayer({
  title: 'Hidroperíodo 1995-1996',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9596_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer34.setVisible(false);
  
const layer35 = new TileLayer({
  title: 'Hidroperíodo 1994-1995',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9495_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer35.setVisible(false);
  
const layer36 = new TileLayer({
  title: 'Hidroperíodo 1993-1994',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9394_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer36.setVisible(false);
  
const layer37 = new TileLayer({
  title: 'Hidroperíodo 1992-1993',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9293_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer37.setVisible(false);
  
const layer38 = new TileLayer({
  title: 'Hidroperíodo 1991-1992',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9192_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer38.setVisible(false);
  
const layer39 = new TileLayer({
  title: 'Hidroperíodo 1990-1991',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H9091_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer39.setVisible(false);
  
const layer40 = new TileLayer({
  title: 'Hidroperíodo 1989-1990',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H8990_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer40.setVisible(false);
  
const layer41 = new TileLayer({
  title: 'Hidroperíodo 1988-1989',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H8889_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer41.setVisible(false);
  
const layer42 = new TileLayer({
  title: 'Hidroperíodo 1987-1988',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H8788_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer42.setVisible(false);
  
const layer43 = new TileLayer({
  title: 'Hidroperíodo 1986-1987',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H8687_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer43.setVisible(false);
  
const layer44 = new TileLayer({
  title: 'Hidroperíodo 1985-1986',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H8586_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer44.setVisible(false);
  
const layer45 = new TileLayer({
  title: 'Hidroperíodo 1984-1985',
  source: new TileWMS({
    url: urlWMSHidroperiodo,
    params: {LAYERS: 'H8485_v01', format: formatoPNG},
    gutter: 200,
  })
});
layer45.setVisible(false);

export const grupoCapa04 = new LayerGroup({
  title: 'Capas de Hidroperíodo',
  fold: 'close',
  layers: [layer09,layer10,layer11,layer12,layer13,layer14,layer15,layer16,layer17,layer18,layer19,layer20,layer21,layer22,layer23,layer24,layer25,layer26,layer27,layer28,layer29,layer30,layer31,layer32,layer33,layer34,layer35,layer36,layer37,layer38,layer39,layer40,layer41,layer42,layer43,layer44,layer45]
});